var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn btn-outline-success"},_vm.$listeners),[_c('i',{staticClass:"icon-database-add mr-2"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }